export { default as TenantsTable } from './TenantsTable';
